/**
 * Created by lichunbo on 2017/3/30.
 */

const favService = {};

let iosRightVersion = '6.7.1';

let bizCode = null;

let androidRightVersion = '6.8.6';

const favRequest = {};

let isWeex = typeof callNative === 'function';
/* global weex */
/* eslint no-undef: "error" */
let weexF = typeof weex === 'object' ? weex : null;
/* 使用收藏服务需要先init初始化业务码，向服务端申请 */
favService.init = function(bizCodeTemp) {
  bizCode = bizCodeTemp;
};
/* 仅提供给线下调试使用，给定一个版本号a，当前app版本号高于a则会使用windvane */
favService.mockRightTaoVersion = function(iosVersion, androidVersion) {
  iosRightVersion = iosVersion;
  androidRightVersion = androidVersion;
};

/* 商品是否收藏 */
favService.isFavoriteItem = function(itemId, successCallback, errorCallback) {
  if (itemId === null || itemId === undefined) {
    itemId = '';
  } else {
    itemId = itemId + '';
  }
  if (itemId.length === 0) {
    errorCallback && errorCallback({
      errorCode: 'NO_ITEMID',
      errorMsg: '参数错误'
    });
    return;
  }

  let ids = [itemId];
  let data = {
    ids: JSON.stringify(ids),
    appName: bizCode,
    type: 1
  };
  let mtopParams = {
    // 通用参数
    api: 'mtop.taobao.mercury.checkCollect', // 必须
    v: '2.0', // 必须
    data: data, // 必须（注意1）
    ecode: 1,
    needLogIn: true,
    sessionOption: 'AutoLoginOnly', // Session 失效时的操作
    LoginRequest: false
  };

  let windvaneParams = {
    class: 'TBFavoriteJSBridge',
    method: 'isFavoriteItem',
    data: {
      bizCode: bizCode,
      itemId: itemId
    }
  };

  favRequest.uniteRequest(mtopParams, windvaneParams, function(result) {

    if (result && typeof(result) !== 'object') {
      result = JSON.parse(result);
    }
    let isFavorite = false;

    if (result && result.data && (result.data.isFavorite !== false
      && result.data.isFavorite !== true)) {
      // Android特殊处理
      result.data = JSON.parse(result.data);
    }

    if (result && result.result && result.result[itemId]) {
      // MTOP
      isFavorite = result.result[itemId];
    } else if (result && result.data) {
      // WindVane
      isFavorite = result.data.isFavorite;
    } else {
      isFavorite = false;
    }
    let success = {
      data: {isFavorite: isFavorite}
    };
    successCallback && successCallback(success);
  }, errorCallback);
};
/* 添加收藏的商品 */
favService.addFavoriteItem = function(itemId, successCallback, errorCallback) {
  if (itemId === null || itemId === undefined) {
    itemId = '';
  } else {
    itemId = itemId + '';
  }
  if (itemId.length === 0) {
    errorCallback && errorCallback({
      errorCode: 'NO_ITEMID',
      errorMsg: '参数错误'
    });
    return;
  }

  let data = {
    itemId: itemId,
    appName: bizCode,
    bizCode: bizCode
  };
  let mtopParams = {
    // 通用参数
    api: 'mtop.taobao.mercury.addCollect', // 必须
    v: '1.0',  // 必须
    data: data, // 必须（注意1）
    ecode: 1,   // 必须（注意2）0为其他，1为登录
    needLogIn: true,
    LoginRequest: true
  };
  let windvaneParams = {
    class: 'TBFavoriteJSBridge',
    method: 'addFavoriteItem',
    data: data
  };

  favRequest.uniteRequest(mtopParams, windvaneParams, function(result) {
    let success = {
      'data': {'isSuccess': 'true'}
    };
    successCallback && successCallback(success);
  }, errorCallback);
};
/* 删除单个收藏的商品 */
favService.deleteFavoriteItem = function(itemId, successCallback, errorCallback) {
  if (itemId === null || itemId === undefined) {
    itemId = '';
  } else {
    itemId = itemId + '';
  }
  if (itemId.length === 0) {
    errorCallback && errorCallback({
      errorCode: 'NO_ITEMID',
      errorMsg: '参数错误'
    });
    return;
  }

  favService.deleteFavoriteItems([itemId], successCallback, errorCallback);
};
/* 删除多个收藏的商品 */
favService.deleteFavoriteItems = function(itemIds, successCallback, errorCallback) {
  if (Array.isArray(itemIds) && itemIds.length === 0) {
    errorCallback && errorCallback({
      errorCode: 'NO_ITEMIDS',
      errorMsg: '参数错误'
    });
    return;
  }

  let data = {
    itemIds: JSON.stringify(itemIds),
    appName: bizCode,
    bizCode: bizCode,
    favType: 1
  };
  let mtopParams = {
    // 通用参数
    api: 'mtop.taobao.mercury.delCollects', // 必须
    v: '1.0',  // 必须
    data: data, // 必须（注意1）
    ecode: 1,   // 必须（注意2）0为其他，1为登录
    needLogIn: true,
    LoginRequest: true
  };
  let windvaneParams = {
    class: 'TBFavoriteJSBridge',
    method: 'deleteFavoriteItems',
    data: {
      itemIds: itemIds,
      appName: data.appName,
      bizCode: data.bizCode,
      favType: data.favType
    }
  };

  favRequest.uniteRequest(mtopParams, windvaneParams, function(result) {
    let success = {
      'data': {'isSuccess': 'true'}
    };
    successCallback && successCallback(success);
  }, errorCallback);
};
/* 内容是否收藏 */
favService.isFavoriteContent = function(params, successCallback, errorCallback) {
  let data = {
    appName: bizCode,
    bizId: params.bizId,
    outItemId: params.outItemId
  };
  let mtopParams = {
    // 通用参数
    api: 'mtop.taobao.mercury.content.iscollected', // 必须
    v: '2.0',  // 必须
    data: data, // 必须（注意1）
    ecode: 1,   // 必须（注意2）0为其他，1为登录
    sessionOption: 'AutoLoginOnly',  // Session 失效时的操作
    LoginRequest: false
  };
  let windvaneParams = {
    class: 'TBFavoriteJSBridge',
    method: 'isFavoriteContent',
    data: {
      bizCode: bizCode,
      bizId: params.bizId,
      outItemId: params.outItemId
    }
  };
  /* IOS的native代码有问题，会导致所有内容返回true，内容方面的是否收藏都走mtop，需要等ios改对了，升级ios方面的version版本才行 */
  windvaneParams = null;

  favRequest.uniteRequest(mtopParams, windvaneParams, function(result) {
    if (result && typeof(result) !== 'object') {
      result = JSON.parse(result);
    }
    let isFavorite = false;
    if (result && (result.result === 'true' || result.result === true)) {
      isFavorite = true;
    } else if (result && result.data) {
      // IOS和android上windvane返回的不一样
      if (result.data.isFavorite === false || result.data.isFavorite === true) {
        isFavorite = result.data.isFavorite;
      } else {
        let jsonData = JSON.parse(result.data);
        isFavorite = jsonData.isFavorite;
      }
    } else {
      isFavorite = false;
    }
    let success = {
      data: {isFavorite: isFavorite}
    };
    successCallback && successCallback(success);
  }, errorCallback);
};
/* 添加内容收藏 */
favService.addFavoriteContent = function(params, successCallback, errorCallback) {
  let data = {
    appName: bizCode,
    bizId: params.bizId,
    contentUrl: params.contentUrl,
    title: params.title,
    picUrl: params.picUrl,
    note: params.note,
    outItemId: params.outItemId
  };
  let mtopParams = {
    // 通用参数
    api: 'mtop.taobao.mercury.collectContent', // 必须
    v: '2.0',  // 必须
    data: data, // 必须（注意1）
    ecode: 1,   // 必须（注意2）0为其他，1为登录
    needLogIn: true,
    LoginRequest: true
  };
  let windvaneParams = {
    class: 'TBFavoriteJSBridge',
    method: 'addFavoriteContent',
    data: {
      bizCode: bizCode,
      bizId: params.bizId,
      contentUrl: params.contentUrl,
      title: params.title,
      picUrl: params.picUrl,
      note: params.note,
      outItemId: params.outItemId
    }
  };
  /* IOS的native代码有问题，内容方面的添加都走mtop */
  windvaneParams = null;

  favRequest.uniteRequest(mtopParams, windvaneParams, function(result) {
    let success = {
      data: {isSuccess: 'true'}
    };
    successCallback && successCallback(success);
  }, errorCallback);
};
/* 删除内容收藏 */
favService.deleteFavoriteContent = function(params, successCallback, errorCallback) {

  let data = {
    appName: bizCode,
    bizId: params.bizId,
    outItemId: params.outItemId
  };
  let mtopParams = {
    // 通用参数
    api: 'mtop.taobao.mercury.deleteContent', // 必须
    v: '2.0',  // 必须
    data: data, // 必须（注意1）
    ecode: 1,   // 必须（注意2）0为其他，1为登录
    needLogIn: true,
    LoginRequest: true
  };
  let windvaneParams = {
    class: 'TBFavoriteJSBridge',
    method: 'deleteFavoriteContent',
    data: {
      bizCode: bizCode,
      bizId: params.bizId,
      outItemId: params.outItemId
    }
  };

  favRequest.uniteRequest(mtopParams, windvaneParams, function(result) {
    let success = {
      data: {isSuccess: 'true'}
    };
    successCallback && successCallback(success);
  }, errorCallback);
};

/* 对mtop返回结果进行处理 */
function parseRes(_res) {
  let res = _res ? _res : {};
  let data = res.data ? res.data : null;
  let ret = res.ret && res.ret[0];
  let result = ret ? ret.split('::') : ['SUCCESS', '调用成功'];
  let code = result[0],
    message = result[1];
  return {
    code: code,
    message: message,
    data: data
  };
}
/* 使用web mtop进行请求 */
function h5MtopRequest(mtopParams, successCallback, errorCallback) {
  let mtop = window.lib.mtop;
  let mtopError;

  if (mtop) {
    let options = {
      api: mtopParams.api,
      v: mtopParams.v,
      ecode: mtopParams.ecode,
      data: mtopParams.data,
      sessionOption: mtopParams.sessionOption,
      LoginRequest: mtopParams.LoginRequest
    };

    mtop.request(options, (res) => {
      let {code, message, data} = parseRes(res);
      if (data) {
        if (code !== 'SUCCESS') {
          mtopError = {
            errorCode: code,
            errorMsg: message
          };
          commitError(mtopParams.api, 'h5Mtop', mtopError.errorCode, mtopError.errorMsg);
          errorCallback && errorCallback(mtopError);
        } else {
          commitSuccess(mtopParams.api, 'h5Mtop');
          successCallback && successCallback(data);
        }
      } else {
        mtopError = {
          errorCode: 'H5_MTOP_NO_DATA',
          errorMsg: '服务调用异常'
        };
        commitError(mtopParams.api, 'h5Mtop', mtopError.errorCode, mtopError.errorMsg);
        errorCallback && errorCallback(mtopError);
      }
    }, (res) => {
      let {code, message} = parseRes(res);
      mtopError = {
        errorCode: code,
        errorMsg: message
      };
      commitError(mtopParams.api, 'h5Mtop', mtopError.errorCode, mtopError.errorMsg);
      errorCallback && errorCallback(mtopError);
    });
  } else {
    mtopError = {
      errorCode: 'NO_MTOP',
      errorMsg: '服务调用失败'
    };
    commitError(mtopParams.api, 'h5Mtop', mtopError.errorCode, mtopError.errorMsg);
    errorCallback && errorCallback(mtopError);
  }
}
/* 使用weex 的mtop进行请求 */
function weexMtopRequest(mtopParams, successCallback, errorCallback) {
  let mtop;
  let mtopError;

  try {
    if (weexF && weexF.requireModule) {
      mtop = weexF.requireModule('mtop');
    } else {
      mtop = require('@weex-module/mtop');
    }
  } catch (error) {
    commitError(mtopParams.api, 'weexMtop', 'weex_mtop_find_error', '找不到weex的mtop');
  }

  if (mtop) {
    let options = {
      api: mtopParams.api,
      v: mtopParams.v,
      needLogin: mtopParams.needLogIn,
      data: mtopParams.data,
      sessionOption: mtopParams.sessionOption
    };
    mtop.request(options, (res) => {
      let {code, message, data} = parseRes(res);
      if (data) {
        if (code !== 'SUCCESS') {
          mtopError = {
            errorCode: code,
            errorMsg: message
          };
          commitError(mtopParams.api, 'weexMtop', mtopError.errorCode, mtopError.errorMsg);
          errorCallback && errorCallback(mtopError);
        } else {
          commitSuccess(mtopParams.api, 'weexMtop');
          successCallback && successCallback(data);
        }
      } else {
        mtopError = {
          errorCode: 'WEEX_MTOP_NO_DATA',
          errorMsg: '服务调用异常'
        };
        commitError(mtopParams.api, 'weexMtop', mtopError.errorCode, mtopError.errorMsg);
        errorCallback && errorCallback(mtopError);
      }
    }, (res) => {
      let {code, message} = parseRes(res);
      mtopError = {
        errorCode: code,
        errorMsg: message
      };
      commitError(mtopParams.api, 'weexMtop', mtopError.errorCode, mtopError.errorMsg);
      errorCallback && errorCallback(mtopError);
    });
  } else {
    mtopError = {
      errorCode: 'NO_WEEX_MTOP',
      errorMsg: '服务调用失败'
    };
    commitError(mtopParams.api, 'weexMtop', mtopError.errorCode, mtopError.errorMsg);
    errorCallback && errorCallback(mtopError);
  }
}

/* 使用web windvane进行jsbridge的调用 */
function h5Windvane(mtopParams, windvaneParams, successCallback, errorCallback) {
  let windvane = window.lib.windvane;
  if (windvane) {
    windvane.call(windvaneParams.class, windvaneParams.method, windvaneParams.data, function(result) {
      commitSuccess(mtopParams.api, 'h5Windvane');
      successCallback && successCallback(result);
    }, function(error) {
      if (error && error.errorCode && error.errorCode !== 'degrade_jsbridge') {
        commitError(mtopParams.api, 'h5Windvane', error.errorCode, error.errorMsg);
        errorCallback && errorCallback(error);
      } else {
        h5MtopRequest(mtopParams, successCallback, errorCallback);
      }

    });
  } else {
    h5MtopRequest(mtopParams, successCallback, errorCallback);
  }

}
/* 使用weex windvane进行调用 */
function weexWindvane(mtopParams, windvaneParams, successCallback, errorCallback) {
  let windvane;
  try {
    if (weexF && weexF.requireModule) {
      windvane = weexF.requireModule('windvane');// .vue
    } else {
      windvane = require('@weex-module/windvane'); // .we;
    }
  } catch (error) {
    commitError(mtopParams.api, 'weexWindvane', 'weex_windvane_find_error', '找不到weex的windvane');
    weexMtopRequest(mtopParams, successCallback, errorCallback);
    return;
  }
  if (windvane) {
    windvane.call(windvaneParams, function(ret) {
      let jsonResult = JSON.parse(ret);
      if (jsonResult.data) {
        commitSuccess(mtopParams.api, 'weexWindvane');
        successCallback && successCallback(ret);
      } else if (jsonResult.errorCode && jsonResult.errorCode !== 'degrade_jsbridge') {
        commitError(mtopParams.api, 'weexWindvane', jsonResult.errorCode, jsonResult.errorMsg);
        errorCallback && errorCallback(ret);
      } else {
        commitError(mtopParams.api, 'weexWindvane', 'weex_jsbridge_find_error', '找不到weex的jsbridge中的方法');
        weexMtopRequest(mtopParams, successCallback, errorCallback);
      }

    });
  } else {
    weexMtopRequest(mtopParams, successCallback, errorCallback);
  }
}

/* 判断app版本是否是淘宝并且是否大于约定的版本
 * 可能返回null、false、true，为true则表明确定是高于targetVersion，否则不是 */
function isTaoBaoRightVersion() {
  let targetVersion;
  let result;
  if (isWeex) {
    // 这边有淘宝就会有windvane
    if (window.WXEnvironment && window.WXEnvironment.appName === 'TB') {
      let platform = window.WXEnvironment.platform;

      if (platform) {
        platform = platform.toLowerCase();
      }

      if (platform === 'ios') {
        targetVersion = iosRightVersion;
      } else if (platform === 'android') {
        targetVersion = androidRightVersion;
      } else {
        return false;
      }
      let currentVersion = window.WXEnvironment.appVersion;
      result = isVersionHigher(currentVersion, targetVersion);
    } else {
      result = false;
    }
  } else {
    const userAgent = window.navigator.userAgent;
    if (userAgent && userAgent.match(/WindVane/i) && userAgent.match(/AliApp\(TB\/(\S*)\)/)) {
      let isAndroid = userAgent.match(/Android/i);
      let isIOS = userAgent.match(/iPhone/i);
      if (isIOS) {
        targetVersion = iosRightVersion;
      } else if (isAndroid) {
        targetVersion = androidRightVersion;
      } else {
        return false;
      }
      let currentVersion = userAgent.match(/AliApp\(TB\/(\S*)\)/)[1];
      result = isVersionHigher(currentVersion, targetVersion);
    } else {
      result = false;
    }
  }
  return result;
}
// 高于返回true，低于返回false，否则无法判断返回null,只针对targetVersion为3位数字的版本
/* 判断版本号a是否高于b */
function isVersionHigher(a, b) {
  let pa = a.split('.');
  let pb = b.split('.');
  for (let i = 0; i < 3; i++) {
    let na = Number(pa[i]);
    let nb = Number(pb[i]);
    if (na > nb) {
      return true;
    }
    if (nb > na) {
      return false;
    }
    if (!isNaN(na) && isNaN(nb)) {
      return true;
    }
    if (isNaN(na) && !isNaN(nb)) {
      return false;
    }
  }
  return null;
}
/* 统一请求方法 */
favRequest.uniteRequest = function(mtopParams, windvaneParams, successCallback, errorCallback) {
  // 首先判断是否是weex环境
  if (isWeex) {
    // 如果是weex环境并且在正确版本的手淘上，先使用windvane调用手淘native的收藏服务
    if (isTaoBaoRightVersion() && windvaneParams) {
      weexWindvane(mtopParams, windvaneParams, successCallback, errorCallback);
    } else {
      // 进行weex的mtop调用
      weexMtopRequest(mtopParams, successCallback, errorCallback);
    }
  } else {
    // 如果是h5环境并且在正确版本的手淘上，先使用windvane调用手淘native的收藏服务
    if (isTaoBaoRightVersion() && windvaneParams) {
      h5Windvane(mtopParams, windvaneParams, successCallback, errorCallback);
    } else {
      // 进行h5的mtop调用
      h5MtopRequest(mtopParams, successCallback, errorCallback);
    }
  }

};
/* 使用usertrack或者goldlog提交错误信息 */
function commitError(requestName, requestMethod, errorCode, errorMsg) {

}
/* 使用usertrack或者goldlog提交正确信息 */
function commitSuccess(requestName, requestMethod) {

}


module.exports = favService;


// WEBPACK FOOTER //
// ./src/Util/FavSDK.js